<template>
	<div class="personinfo-card">
		<div class="card-title">
			<img class="icon" src="../icons/icon/家庭成员.png" alt="" />
			<span class="title">
				<span class="family-title-fontSize">
					主要家庭成员
					<span style="font-size:13px;color:red">(内部招聘时为必填项)</span>
				</span>
			</span>
			<!-- <span class="family-title-fontSize2" @click="add" v-show="addFlag">
      新增附件
      </span>
      <span class="family-title-fontSize2" v-show="addFlag2" @click="submit">
      保存
      </span> -->
			<div class="opt-right">
				<el-button @click="add" :disabled="isDisabled" type="primary" size="mini"
					><i class="el-icon-plus el-icon--left"></i>新增</el-button
				>
			</div>
		</div>

		<div class="card-body">
			<div class="body-item" v-for="(formData, index) in formDatas" v-bind:key="index">
				<div class="body-item-tools">
					<i class="el-icon-delete delete" @click="removeData(formData.oid)" v-show="isDisabled == false"></i>
				</div>

				<el-form
					:inline="true"
					:model="formData"
					ref="formData"
					class="form_data"
					label-width="100px"
					:rules="rules"
					size="medium"
					:disabled="isDisabled"
				>
					<el-form-item label="称谓" prop="relation">
						<el-select v-model="formData.relation">
							<el-option v-for="(item, index) in relationList" :key="index" :label="item" :value="item">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="姓名" prop="name">
						<el-input v-model="formData.name" :maxlength="120" />
					</el-form-item>

					<el-form-item label="出生日期" prop="birthdate">
						<el-date-picker v-model="formData.birthdate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="政治面貌" prop="polity">
						<el-select v-model="formData.polity">
							<el-option v-for="item in polityList" :key="item.oid" :label="item.name" :value="item.oid">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="工作单位" prop="workcorp">
						<el-input v-model="formData.workcorp" :maxlength="120" />
					</el-form-item>
					<el-form-item label="职务/岗位" prop="post">
						<el-input v-model="formData.post" :maxlength="120" />
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import { dictData } from "../request/resumeApi";
import { mapActions } from "vuex";

export default {
	props: {
		VOStatus: {
			type: String,
			default: () => {
				return "view";
			},
		},
		formFlag: {
			type: Number,
			default: () => {
				return 1;
			},
		},
	},
	data() {
		return {
			// 用户填写信息
			formDatas: [],
			formDataNew: [],
			familyForm: {
				oid: 0,
				relation: "",
				name: "",
				birthdate: "",
				polity: "",
				workcorp: "",
				post: "",
			},
			id: 0,
			assinList: [], //赋值
			addNewList: [], //新增
			addFlag: true,
			submitFlag: false,
			fListFlag: false,
			flag: false,
			currentLiStyle: 0,
			rules: {
				relation: [{ required: true, message: "请输入家庭成员称呼", trigger: "blur" }],
				name: [
					{ required: true, message: "请输入家庭成员姓名", trigger: "blur" },
					// { max: 120, message: '不能超过120个字符', trigger: 'blur' }
				],
				polity: [
					{
						required: true,
						message: "请输入家庭成员政治面貌",
						trigger: "blur",
					},
				],
				workcorp: [
					{
						required: true,
						message: "请输入家庭成员工作单位",
						trigger: "blur",
					},
					// { max: 2000, message: '不能超过2000个字符', trigger: 'blur' }
				],
				post: [
					{ required: true, message: "请输入家庭成员职务", trigger: "blur" },
					// { max: 2000, message: '不能超过2000个字符', trigger: 'blur' }
				],
				birthdate: [
					{
						type: "string",
						required: true,
						message: "请选择家庭成员出生日期",
						trigger: "change",
					},
				],
			},
			polityList: [],
			relationList: ["父亲", "母亲", "儿子", "女儿", "哥哥", "姐姐", "弟弟", "妹妹", "丈夫", "妻子", "其他"],
		};
	},
	mounted() {
		this.dictData("bd_polity", "polityList", false);
		this.initForm();
	},
	computed: {
		isDisabled: function() {
			if (this.$props.VOStatus == "view") {
				return true;
			} else if (this.$props.VOStatus == "edit") {
				return false;
			} else if (this.$props.VOStatus == "new") {
				return false;
			}
			return true;
		},
	},
	methods: {
		...mapActions(["globalDictDataRequest"]),
		//获取字典
		dictData(type, list, isBlank) {
			// let data = {
			//   type: type
			// }
			// dictData(data, isBlank).then(response => {
			//   // console.log(response)
			//   this[list] = response.data
			// });
			return this.globalDictDataRequest({ key: type, cacheName: list }).then((res) => {
				// 深拷贝数据
				let data = [...res].map((item) => {
					return { ...item };
				});
				if (isBlank) {
					data.unshift({
						name: "请选择...",
						code: "0",
						oid: 0,
					});
				}
				this[list] = data;
				return res;
			});
		},
		//新增成员
		add() {
			let newOid = new Date().getTime();
			this.formDataNew.push(newOid);

			this.formDatas.push({
				oid: newOid,
				relation: "",
				name: "",
				birthdate: "",
				polity: "",
				workcorp: "",
				post: "",
			});
		},
		removeData(oid) {
			this.formDatas = this.formDatas.filter((item) => oid != item.oid);
			this.formDataNew = this.formDataNew.filter((item) => oid != item);
		},
		clearFormData() {
			// 重置数据
			this.formDatas = [];
			this.formDataNew = [];
		},
		resetFormData() {
			// 重置数据
			if (!this.$refs.formData || !this.$refs.formData.length || this.$refs.formData.length == 0) {
				return;
			}

			for (let index in this.$refs.formData) {
				this.$refs.formData[index].resetFields();
			}
		},
		formAllValidate() {
			// 表单验证
			return new Promise(
				function(resolve) {
					if (!this.$refs.formData || !this.$refs.formData.length || this.$refs.formData.length == 0) {
						resolve({
							type: "familyMember",
							status: "ok",
							msg: "没有数据,验证通过",
						});
					}

					var validateAll = [];

					for (let index in this.$refs.formData) {
						validateAll.push(this.$refs.formData[index].validate());
					}

					Promise.all(validateAll)
						.then((values) => {
							//console.log(values);
							resolve({
								type: "familyMember",
								status: "ok",
								msg: "验证通过",
							});
						})
						.catch((e) => {
							//console.log(e);
							resolve({
								type: "familyMember",
								status: "fail",
								msg: "【家庭成员】页签验证不通过",
							});
						});
				}.bind(this)
			);
		},
		formGetValue() {
			// 页面获取值
			return this.formDatas.map((item) => {
				if (this.formDataNew.includes(item.oid)) {
					item.oid = 0;
				}
				return item;
			});
		},
		setFormDatas(datas) {
			// 设置数据
			this.formDataNew = [];

			this.formDatas = datas.map((item) => {
				var newItem = {};
				// familyForm
				for (let k in this.familyForm) {
					if (item[k]) {
						newItem[k] = item[k].key;
					}
				}
				return newItem;
			});
		},
		//保存
		submit() {
			this.add();
			this.assinList.push({
				relation: { value: this.familyForm.relation },
				name: { value: this.familyForm.name },
				birthdate: { value: this.familyForm.birthdate },
				polity: { value: this.familyForm.polity },
				workcorp: { value: this.familyForm.workcorp },
				post: { value: this.familyForm.post },
			});
			this.addNewList.push({
				relation: this.familyForm.relation,
				name: this.familyForm.name,
				birthdate: this.familyForm.birthdate,
				polity: this.familyForm.polity,
				workcorp: this.familyForm.workcorp,
				post: this.familyForm.post,
			});
			// this.$refs['familyForm'].resetFields()
		},
		//表单初始化
		initForm() {
			if (this.formFlag == 1) {
				this.flag = false;
				this.fListFlag = !this.fListFlag;
			}
		},
		//提交表单
		// validForm() {
		//   this.$refs['familyForm'].validate((valid) => {
		//     if (valid) {
		//       this.flag = true;
		//       //  this.resetForm(formName)
		//     } else {
		//       return false;
		//     }
		//   });
		// },
		//家庭成员选中框
		familyView(index) {
			//console.log(index);
			this.currentLiStyle = index;
		},
		//  表单重置
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
	},
};
</script>

<style lang="scss" scoped>
.personinfo-card {
	// line-height: 40px;
	width: 960px;
	margin-left: 14px;
	margin-right: 2px;
	.card-title {
		position: relative;

		// border-bottom: 1px solid #ebebeb;
		margin-bottom: 20px;

		.icon {
			display: inline-block;
			height: 40px;
			vertical-align: middle;
		}

		.title {
			line-height: 40px;
			display: inline-block;
			font-size: 18px;
			font-weight: bold;
			color: #01539f;
			vertical-align: middle;
		}

		&::after {
			content: "";
			position: absolute;
			left: 0;
			right: 0;
			bottom: -12px;
			height: 1px;
			background: #ebebeb;
		}

		.opt-right {
			position: absolute;
			right: 12px;
			top: 0px;
			height: 40px;
			line-height: 40px;

			.el-button {
				border: none;
				border-radius: 0px;
			}
		}
	}

	.card-body {
		.body-item {
			border: 1px solid #eee;
			border-radius: 12px;
			padding: 12px;
			margin-bottom: 20px;
		}

		.body-item-tools {
			height: 30px;
			.delete {
				float: right;
				margin-top: 6px;
				font-size: 18px;
				color: rgba(255, 0, 0, 0.85);
				cursor: pointer;
			}

			.delete:hover {
				color: rgba(255, 0, 0);
			}

			.delete:active {
				opacity: 0.5;
			}
		}

		.form_data {
		}
	}
}

.form_data {
	.el-input {
		width: 340px;
	}

	.el-select {
		width: 340px;
	}

	.awardcorp-wrap {
		.el-textarea__inner {
			resize: none;
		}
	}
}

::v-deep .el-select {
}
</style>
